export enum ESoldOnOptions {
  Phone = "Phone",
  Site = "Site",
  SwyftStore = "Swyft Store",
  BankTransfer = "Bank Transfer / Other"
}
